<div class="toast-stack" aria-live="polite" aria-atomic="true">
  <div *ngFor="let toast of notificationService.toasts()"
       class="toast"
       [ngClass]="classFor(toast.type)"
       role="status">
    <span class="toast__message">{{ toast.message }}</span>
    <button type="button"
            class="toast__close"
            aria-label="Fermer"
            (click)="dismiss(toast.id)">×</button>
  </div>
</div>
